module.exports = __webpack_public_path__ + "img/vector.7a65c427.svg";